export const FONT_DISPLAY =
  '"Iowan Old Style", "Palatino Linotype", "Book Antiqua", Georgia, serif';

export const FONT_UI =
  '"Avenir Next", "Trebuchet MS", "Segoe UI", sans-serif';

export const PALETTE = {
  night: 0x08131a,
  nightSoft: 0x0d1f24,
  forest: 0x183a35,
  surface: 0x132229,
  surfaceSoft: 0x1d2e33,
  mist: 0xb8c2bb,
  ink: 0xf4efe5,
  accent: 0xeab85c,
  accentHover: 0xf1cb7a,
  kiwi: 0x83ba45,
  kiwiDark: 0x2b4a29,
  coconut: 0xe6d6b2,
  coconutDark: 0x7d6749,
  danger: 0xd86d58,
};
